const KEY = "codeshare:run-entry";

type Store = Pick<Storage, "getItem" | "setItem">;
const storage = (): Store | null => {
  try {
    return globalThis.localStorage ?? null;
  } catch {
    return null;
  }
};

/** The file "Always run …" pinned for a workspace (a room's topic, or "local"), on this device. */
export function loadPinnedEntry(workspace: string, store = storage()): string | undefined {
  try {
    const all = JSON.parse(store?.getItem(KEY) ?? "{}") as Record<string, string>;
    return typeof all[workspace] === "string" ? all[workspace] : undefined;
  } catch {
    return undefined;
  }
}

export function savePinnedEntry(
  workspace: string,
  path: string | undefined,
  store = storage(),
): void {
  try {
    const all = JSON.parse(store?.getItem(KEY) ?? "{}") as Record<string, string>;
    if (path) all[workspace] = path;
    else delete all[workspace];
    store?.setItem(KEY, JSON.stringify(all));
  } catch {}
}
